import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  href = '#comprar',
  className = '',
  onClick
}: ButtonProps) {
  const content = <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`
        relative overflow-hidden group
        bg-gradient-to-b from-gold-400 to-gold-600
        text-navy-950 font-bold text-lg md:text-xl
        py-4 px-8 rounded-xl shadow-lg
        flex items-center justify-center gap-2
        transition-all duration-300
        hover:shadow-gold-500/40 hover:shadow-2xl
        w-full sm:w-auto
        ${className}
      `} data-id="element-321">
      <span className="relative z-10 flex items-center gap-2" data-id="element-322">
        {children}
        <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-323" />
      </span>
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/30 to-transparent z-0" data-id="element-324" />
    </motion.button>;
  if (href) {
    return <a href={href} className="inline-block w-full sm:w-auto" data-id="element-325">
        {content}
      </a>;
  }
  return content;
}